import React from "react";
import imagesSizes from "constants/imagesSizes";
import TrendingStoryCard from "components/stories/TrendingStoryCard";
import { PostStoryProvider, usePostStoryContext } from "./contexts/PostStoryContext";
import { PostStoryProviderProps } from "./types";
import { TriggerButton, PostStoryModal } from "./common";

const PostStoryContent: React.FC = ({ children }) => {
  const {
    state: { selectedPrompt, selectedMedia } = {},
    open,
    isTrendingStory,
    isProfile,
    selectedStory,
    showPoints,
    startYourTrend,
    onOpen,
    onStoryClick
  } = usePostStoryContext();

  return (
    <>
      {open && <PostStoryModal />}
      {typeof children === "function" && children(onOpen)}
      {isTrendingStory && (
        <TrendingStoryCard
          story={selectedPrompt}
          onOpen={onOpen}
          selectedImage={selectedMedia}
          isProfile={isProfile}
          onStoryClick={onStoryClick}
          selectedStory={selectedStory}
          showPoints={showPoints}
        />
      )}
      {startYourTrend && <TriggerButton imgSize={imagesSizes.THUMB} />}
    </>
  );
};

const PostStory: React.FC<PostStoryProviderProps> = props => {
  const { children } = props;

  return (
    <PostStoryProvider {...props}>
      <PostStoryContent>{children}</PostStoryContent>
    </PostStoryProvider>
  );
};

export default PostStory;
